import React from "react";

const FAQComponent = () => {
  return (
    <>
      <section className="Faq">
        <div className="container">
          <div className="row">
            <div className="col-md-12  m-auto">
              <h2 className="title">Frequently asked questions</h2>
              <div className="FrequentlyBorder">
                <div className="row">
                  <div className="col-12">
                    <div className="faqContent">
                      <div className="faq faqbrdTop">
                        <a href="#!;" className="expand-btn open">
                          What are the eligibility criteria for the Probationary Officer Program?{" "}
                        </a>
                        <div
                          className="hidden-content"
                          style={{ display: "block" }}
                        >
                          Applicants below 25 years of age and who have completed Graduation or Engineering in any discipline this year with 60% in 10th Standard and Graduation can apply. Post-Graduates or MBA freshers may also apply. Total work experience of the applicant should not exceed 2 years. Applicants should not exceed 25 years of age as on the date of application.
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                      I don’t have banking experience. Will I be considered for the Probationary Officer Program?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>
                           Banking experience is not mandatory to apply for the Probationary Officer Program. The training program prepares the applicant to understand banking and take up the role of a Relationship Manager in Sales. The Probationary Officer Program will orient the applicant to the culture of ICICI Bank and various aspects of banking like products, solutions, processes, systems, importance of risk management and compliance, identifying opportunities based on customer needs and providing appropriate solutions to the customer.
                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                        What is the Relationship Manager role about?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>
                            After completing the Probationary Officer Program, you would take up the role of a Relationship Manager. Please find below the description of the role of a Relationship Manager.</p>
                            <p>A Relationship Manager is a core anchor in taking our banking solutions and services to our valuable customers. This involves a 360-degree banking approach. The Relationship Managers should have an inclination to understand the customer needs and offer solutions in line with the needs. The core philosophy is ‘Fair to the Customer and Fair to the Bank’. At ICICI Bank, our customer-centric Relationship Managers are responsible for acquiring new customer relationships and increasing the wallet share of existing customer relationships with a resolute focus on service quality and customer delight. They collaborate and work with different internal teams, thereby offering the best-in-class customer service. In line with our philosophy of taking the entire Bank to the customers, our Relationship Managers work on the whole suite of offerings like savings solutions, loan products, overdraft solutions, insta loans, investment solutions, care products, trade solutions, business loans or wealth management solutions 

                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                         What is the location of the residential program?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>Currently the Probationary Officer Program is held at two locations: </p>
                            <p>
                              A) ICICI Manipal Academy, Bengaluru and
                          </p>
                          <p>
                            B) NIIT University (NU) at Neemrana
                          </p>
                          <p>
                            Both of these campuses have residential facility.
                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          Will I have to bear the cost for training and stay at these training facilities?{" "}
                        </a>
                        <div className="hidden-content">
                          <p>
                          The cost of training and stay during the 2 months of training shall be borne by ICICI Bank. During the program, the trainees shall receive a stipend of ₹18,000 per month (Rupees Eighteen Thousand only).
                          </p>
                        </div>
                      </div>
                      <div className="faq">
                        <a href="#!;" className="expand-btn">
                          Will I get a job at ICICI Bank after completing the program? {" "}
                        </a>
                        <div className="hidden-content">
                          <p>
                           The applicants who join the Probationary Officer Program are called ‘Trainees’. These trainees will undergo rigorous training including regular assessments and viva at the end of the term as part of the Probationary Officer Program. Only those trainees who successfully complete the Probationary Officer Program shall be extended an offer letter by the Bank and shall be placed at any location of the Bank in the role of a Relationship Manager (Sales).
                          </p>
                        </div>
                      </div>
                      <div className="moretext" id="hidetxt5">
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is taught in the program?{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                              The program inculcates the philosophy of ‘Seva Bhav’ (‘Service Orientation’ with values of humility, adaptability and a zeal to learn) and cultural ethos of ICICI Bank. In addition to that, the Probationary Officer Program will train you in various aspects of banking like banking products, solutions, processes, systems, importance of risk management and compliance, identifying opportunities based on customer needs and providing appropriate solutions to customers. This program will prepare applicants for the role of Relationship Manager. The role of a Relationship Manager involves continuous client interactions and will require travel within and around the assigned location/city. It is a sales role.
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                          Where will I be posted after completion of the program?{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                             Upon successful completion of the program, the trainee shall be placed in a Relationship Management role at any location across the country, depending on the requirements of the Bank.
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                           What does role & location fungibility mean?{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                              At ICICI Bank, we believe in serving our customers beyond our role definition, product boundaries and domain limitations through our philosophy of customer 360-degree. In essence, this captures our belief in serving the entire banking needs of our customers as One Bank, One Team. To achieve this, employees at ICICI Bank are expected to be role & location-fungible and should be ready to serve customers at all times with the understanding that Banking is an essential service. The role description which gives you an overview of the responsibilities, is only directional and guiding in nature. Upon joining ICICI Bank, one can be posted in any role and location as per the requirement of the Bank.
                           </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                           Please provide the details of the written aptitude test.{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                             Shortlisted applicants for the program are invited to appear for a written aptitude test. The mail communication will have all the relevant details of the aptitude test. The key points are as follows:
                            </p>
                            <ol>
                              <li>It is an online aptitude test for which one can appear from a convenient location which is noise free and does not have any other interference. It requires only the test taker to be present in the vicinity of the laptop/ mobile.</li>
                              <li>It is strongly recommended to appear for the aptitude test using a laptop/ PC. Please avoid taking the test through a mobile phone.</li>
                              <li>The laptop/ PC should have a functioning camera without which you will not be able to appear for the test.</li>
                              <li>The overall duration is 80 minutes.</li>
                              <li>The test comprises four sections (Verbal, Quantitative, Logical ability, General awareness).</li>
                              <li>There is no negative marking.</li>
                            </ol>
                            <p>The pattern of the questions is similar to other competitive exams.</p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            Will I get reimbursement of the cost of travel to the training facility?{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                             The trainees who join the Bank after successful completion of the Probationary Officer Program shall be eligible for reimbursement of the cost of travel by AC tier-III train. This reimbursement will include train travel to the campus and the cost of train travel to the location of posting after successful completion of the Probationary Officer Program. The applicants will be required to book train tickets on their own in AC tier-III class of travel. 
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is the next step after the aptitude test and how do I track the status of my application?{" "} 
                          </a>
                          <div className="hidden-content">
                            <p>The next step after the aptitude test will be an in-person interview. Applicants clearing the aptitude test will be invited for the interview.
                            </p>
                            <p>
                              We recommend that you download the mobile application, iUniverse by ICICI BankTM, available on Play Store and App Store. The section on timelines provides real-time updates on the status of your application. We will also intimate you through e-mail and WhatsApp.
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                           How much time will it take to complete the personal interview process?{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                              {" "}
                            Personal interview will be a day-long process. We request you to plan your schedule accordingly.
                            </p>
                          </div>
                        </div>
                         <div className="faq">
                          <a href="#!;" className="expand-btn">
                            I have a query and need clarification. Whom should I contact?{" "}
                          </a>
                          <div className="hidden-content">
                            <p>
                              You can write to us at {" "}<a href="mailto:icicicareers@icici.bank.in">icicicareers@icici.bank.in </a> . You may also call us at +91-22-7187 2500 during working days. We will be happy to answer your questions.{" "}
                              
                            </p>
                          </div>
                        </div>
                        {/*<div className="faq">
                          <a href="#!;" className="expand-btn">
                            What is the total course fee?
                          </a>
                          <div className="hidden-content">
                            <p>
                              The total course fee amount is ₹2,00,000 +
                              Applicable GST(18%) + 25000*(TAB cost at
                              actuals*)+ Applicable GST(18%){" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            If I choose self funding for the course, in whose
                            name Demand Draft (DD) should be taken?
                          </a>
                          <div className="hidden-content">
                            <p>
                              Demand Draft should be favouring "Manipal Global
                              Education Services Private Limited" payable in
                              Bengaluru.{" "}
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            I will be reaching Bengaluru before the joining
                            dates. Can I get accommodation in the IMA?
                          </a>
                          <div className="hidden-content">
                            <p>
                              {" "}
                              The accommodation at the IMA will be provided
                              after the completion of the joining formalities
                              only.
                            </p>
                          </div>
                        </div>
                        <div className="faq">
                          <a href="#!;" className="expand-btn">
                            Can my parents/guardians be provided with the
                            accommodation at the IMA?
                          </a>
                          <div className="hidden-content">
                            <p>
                              No, accommodation will be provided only to the
                              candidates who complete the joining formalities at
                              ICICI Manipal Academy.{" "}
                            </p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p align="center" className="mt-5">
                <a href="#!" className="btn readmore seeAll" rel="hidetxt5">
                  See all
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQComponent;
